import styled from 'styled-components'
import { Colors } from 'styles/app-styles'

export const Tabs_s = styled.div`
  margin: 10px;
  position: fixed;
  width: calc(100% - 100px);

  div.p-tabview > ul.p-tabview-nav {
    border-bottom: 1px solid #d1d8e1;
    width: calc(100% - 15px);

    li.p-tabview-selected {
      background: #d1d8e1;
      border-radius: 4px 4px 0 0;
    }
    li > a {
      padding: 10px 10px 5px 10px;
      span.p-tabview-title {
        color: ${Colors.blackPearl};
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
`